import { render, staticRenderFns } from "./PageTarifi.vue?vue&type=template&id=4c135f78&scoped=true&"
import script from "./PageTarifi.vue?vue&type=script&lang=js&"
export * from "./PageTarifi.vue?vue&type=script&lang=js&"
import style0 from "./PageTarifi.vue?vue&type=style&index=0&id=4c135f78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c135f78",
  null
  
)

export default component.exports